import type { ReactNode } from 'react'
import React, { useContext as useContextCore } from 'react'
import type { ChangePasswordComponents } from './components'
import { components as defaultComponents } from './components'
import merge from 'lodash/merge'

export type ContextProps = {
  children?: ReactNode
  url: string
  userId?: string
  resetUsername?: string
  resetCode?: string
  navigateTo?: string
  components?: ChangePasswordComponents
  recaptchaSiteKey: string
  withCurrentPasswordForm?: boolean
}

export type ContextType = Omit<ContextProps, 'children'> & { components: ChangePasswordComponents }

const context = React.createContext<ContextType>({} as ContextType)
const CoreProvider = context.Provider

export const Provider = ({ children, components, ...props }: ContextProps) => {
  components = merge({}, defaultComponents, components)

  return <CoreProvider value={{ ...props, components }}>{children}</CoreProvider>
}

export const useContext = () => useContextCore(context)
